export const getWorkflowGraphSelection = ({ graph = {}, stepIds = [] }) => {
  const selectedStepIds = [...new Set(stepIds || [])].filter((stepId) => !!graph?.[stepId]);
  const selectedStepIdSet = new Set(selectedStepIds);
  const selectionGraph = {};

  for (const stepId of selectedStepIds) {
    const node = graph[stepId];
    selectionGraph[stepId] = {
      ...node,
      exit: node?.exit && selectedStepIdSet.has(node.exit) ? node.exit : null,
      child: node?.child && selectedStepIdSet.has(node.child) ? node.child : null,
      branches: Array.isArray(node?.branches) ? node.branches.map((branchId) => (branchId && selectedStepIdSet.has(branchId) ? branchId : null)) : []
    };
  }

  return selectionGraph;
};
